<template>
	<div class="el-tiptap-editor__wrapper">
		<el-tiptap
			:extensions="extensions"
			v-model="content"
			:spellcheck="false"
			:menu-bubble-options="{ 'keep-in-bounds': false }"
			placeholder="Write something ..."
			lang="en"
			v-bind="$attrs"
		/>
	</div>
</template>

<script>
import {
	ElementTiptap,
	Doc,
	Text,
	Paragraph,
	Heading,
	Bold,
	Underline,
	Italic,
	Strike,
	Code,
	Link,
	Image,
	// Blockquote,
	ListItem,
	BulletList,
	// OrderedList,
	// TodoItem,
	// TodoList,
	TextAlign,
	TextColor,
	// Indent,
	HardBreak,
	HorizontalRule,
	CodeView,
	// Fullscreen,
	History,
} from "element-tiptap";
import codemirror from "codemirror";
import "codemirror/mode/xml/xml.js"; // language
import "codemirror/addon/selection/active-line.js"; // require active-line.js
import "codemirror/addon/edit/closetag.js"; // autoCloseTags
import axios from 'axios';
export default {
	props: {
		value: String,
		assignmentType: String,
		assignmentId: Number,
		partnerId: Number,
	},
	components: {
		"el-tiptap": ElementTiptap,
	},
	inheritAttrs: false,
	data() {
		return {
			extensions: [
				new Doc(),
				new Text(),
				new Paragraph(),
				new Heading({ level: 5 }),
				new Bold({ bubble: true }),
				new Underline({ bubble: true }),
				new Italic({ bubble: true }),
				new Strike({ bubble: true }),
				new Code(),
				new Link({ bubble: true }),
				new Image({uploadRequest: this.uploadRequest}),
				new TextAlign({ bubble: true }),
				new TextColor(),
				new ListItem(),
				new BulletList(),
				new HardBreak(),
				new HorizontalRule(),
				new CodeView({
					codemirror,
					codemirrorOptions: {
						styleActiveLine: true,
						autoCloseTags: true,
					},
				}),
				new History(),
			],
		};
	},
	methods: {
		uploadRequest: function(file) {
			const formData = new FormData();
			formData.append('uploadAssignment', this.assignmentType || 'wysiwyg');
			if(this.assignmentId) {
				formData.append('uploadAssignmentId', this.assignmentId);
			}
			if(this.partnerId) {
				formData.append('partnerId', this.partnerId);
			}
			formData.append('files[]', file);
			return axios.post('/medias', formData).then(result =>
				result.data?.[0]?.url
			);
		}
	},
	computed: {
		content: {
			get() {
				return this.value;
			},
			set(html) {
				let formatted = html.replace(/<p><\/p>/g, '<p><br></p>') // hack to preserve breaks when they want to "add space"
                formatted = formatted.replace(/href="([^"]*)"/g, function (match, p1) {
                    return 'href="' + p1.replace(/&amp;/g, '&') + '"';
                });
				this.$emit("input", formatted);
			},
		},
	},
};
</script>

<style lang="scss">
@import '@sass/_mixins';

.el-tiptap-editor {
	&__content {
		@include wysiwyg-content-styles();
	}
}
</style>